interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const TitleLarge = ({ children, className = '' }: TypographyProps) => {
    return (
        <h1 className={`font-outfit font-bold text-[32px] leading-10 lg:text-[68px] lg:leading-[72px] ${className}`}>
            {children}
        </h1>
    );
};